dmx.Component('input', {
    extends: 'form-element',
    tag: 'input'
});
